import { NgModule } from '@angular/core';
import { MigrationsComponent } from './migrations.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ZiroFormsModule } from '../forms/ziro-forms.module';
import { LoadingBlockModule } from '../shared/loading-block/loading-block.module';
import { BreadcrumbsModule } from '../shared/breadcrumbs/breadcrumbs.module';
import { BottomNavModule } from '../shared/bottom-nav/bottom-nav.module';
import { FileUploaderModule } from '../shared/file-uploader/file-uploader.module';
import { TopNavModule } from '../shared/top-nav/top-nav.module';
import { MigrationsTableComponent } from './migrations-table/migrations-table.component';
import { MigrationsCiscoDashboardComponent } from './migrations-cisco/migrations-cisco-dashboard/migrations-cisco-dashboard.component';
import { MigrationsCreateComponent } from './migrations-create/migrations-create.component';
import { MigrationsCreateFormComponent } from './migrations-create/migrations-create-form/migrations-create-form.component';
import { FileUploadBoxComponent } from '../forms/fields/file-upload-box/file-upload-box.component';
import { FileUploadProgressModalComponent } from '../modals/file-upload-progress-modal/file-upload-progress-modal.component';
import { ZiroButtonComponent } from '../button/button.component';
import { MigrationsCiscoDirectoryNumbersReportComponent } from './migrations-cisco/migrations-cisco-directory-number-report/migrations-cisco-directory-numbers-report.component';
import { ReportingModule } from '../reporting/reporting.module';
import { MigrationsCiscoHuntListsReportComponent } from './migrations-cisco/migrations-cisco-hunt-list-report/migrations-cisco-hunt-lists-report.component';
import { MigrationsCiscoHuntListsReportLineGroupsComponent } from './migrations-cisco/migrations-cisco-hunt-list-report/migrations-hunt-list-report-line-groups/migrations-cisco-hunt-lists-report-line-groups.component';
import { MigrationsCiscoComponent } from './migrations-cisco/migrations-cisco.component';
import { MicrosoftCucmE164TransformationRulesContext } from '../shared/contexts/microsoft-cucm-e164-transformation-rules.context';
import { NumberTranslationRulesModalComponent } from '../modals/number-translation-rules-modal/number-translation-rules-modal.component';
import { MigrationsDonutChartComponent } from './migrations-cards/migrations-donut-chart/migrations-donut-chart.component';
import { MigrationsCardAbstractDirective } from './migrations-cards/migrations-card-abstract.directive';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ButtonModule } from 'primeng/button';
import { MigrationsTextCardComponent } from './migrations-cards/migrations-text-card/migrations-text-card.component';
import { MigrationsTextRowComponent } from './migrations-cards/migrations-text-card/migrations-text-row/migrations-text-row.component';
import { MigrationsCardHeaderComponent } from './migrations-cards/shared/migrations-card-header/migrations-card-header.component';
import { MigrationsCiscoAutoAttendantsExplorerComponent } from './migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendant-explorer/migrations-cisco-auto-attendants-explorer.component';
import { ExplorerComponent } from '../shared/explorer/explorer.component';
import { MigrationsAutoAttendantsComponent } from './migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { MigrationsAutoAttendantsDetailedViewComponent } from './migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants-detailed-view/migrations-auto-attendants-detailed-view.component';
import { MigrationsSuggestedCallingProductPipe } from './services/migrations-suggested-calling-product.pipe';
import { MicrosoftBulkProvisioningPollingService } from '../shared/contexts/microsoft-bulk-provisioning-polling.service';
import { StackedIconComponent } from '../shared/stacked-icon/stacked-icon.component';
import { MigrationsRingCentralResource } from './services/ring-central/migrations-ring-central.resource';
import { MigrationsCiscoResource } from './services/cisco/migrations-cisco.resource';
import { DatatableComponent } from '../shared/tables/datatable/datatable.component';
import { DatatableMultiSelectFilterComponent } from '../shared/tables/datatable/datatable-filters/datatable-multi-select-filter/datatable-multi-select-filter.component';
import { MigrationsRingCentralPollingModalComponent } from './migrations-create/migrations-create-form/migrations-ring-central-polling-modal.component';
import { MigrationsRingCentralComponent } from './migrations-ring-central/migrations-ring-central.component';
import { MigrationsRingCentralNumbersReportComponent } from './migrations-ring-central/migrations-ring-central-numbers-report/migrations-ring-central-numbers-report.component';
import { MigrationsRingCentralDashboardComponent } from './migrations-ring-central/migrations-ring-central-dashboard/migrations-ring-central-dashboard.component';
import { RingCentralCallQueueComponent } from './migrations-ring-central/ring-central-call-queues/ring-central-call-queue/ring-central-call-queue.component';
import { RingCentralCallQueuesListViewComponent } from './migrations-ring-central/ring-central-call-queues/ring-central-call-queues-list-view/ring-central-call-queues-list-view.component';
import { MigrationsRoutingModule } from '../../../../main/src/app/routing/migrations-routing.module';
import { RingCentralAutoAttendantsListComponent } from './migrations-ring-central/ring-central-auto-attendants/ring-central-auto-attendants-list.component';
import { RingCentralAutoAttendantsDetailedViewComponent } from './migrations-ring-central/ring-central-auto-attendants/ring-central-auto-attendants-detailed-view/ring-central-auto-attendants-detailed-view.component';
import { MigrationsCiscoSiteManagementComponent } from './site-migration/migrations-cisco-site-management/migrations-cisco-site-management.component';
import { MigrationsCiscoSourceFieldMappingComponent } from './site-migration/migrations-cisco-source-field-mapping/migrations-cisco-source-field-mapping.component';

@NgModule({
  imports: [
    MigrationsRoutingModule,
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    SelectModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    ZiroFormsModule,
    ZiroButtonComponent,
    LoadingBlockModule,
    BreadcrumbsModule,
    BottomNavModule,
    TopNavModule,
    FileUploaderModule,
    FileUploadBoxComponent,
    FileUploadProgressModalComponent,
    ReportingModule,
    NumberTranslationRulesModalComponent,
    NgxChartsModule,
    ButtonModule,
    ExplorerComponent,
    MigrationsCardHeaderComponent,
    PipesModule,
    MigrationsSuggestedCallingProductPipe,
    StackedIconComponent,
    DatatableComponent,
    DatatableMultiSelectFilterComponent,
    MigrationsRingCentralPollingModalComponent,
  ],
  declarations: [
    MigrationsComponent,
    MigrationsTableComponent,
    MigrationsCiscoComponent,
    MigrationsCiscoDashboardComponent,
    MigrationsCreateComponent,
    MigrationsCiscoSiteManagementComponent,
    MigrationsCiscoSourceFieldMappingComponent,
    MigrationsCreateFormComponent,
    MigrationsCiscoDirectoryNumbersReportComponent,
    MigrationsCiscoHuntListsReportComponent,
    MigrationsCiscoHuntListsReportLineGroupsComponent,
    MigrationsDonutChartComponent,
    MigrationsCardAbstractDirective,
    MigrationsTextCardComponent,
    MigrationsTextRowComponent,
    MigrationsCiscoAutoAttendantsExplorerComponent,
    MigrationsAutoAttendantsComponent,
    MigrationsAutoAttendantsDetailedViewComponent,
    MigrationsRingCentralComponent,
    MigrationsRingCentralNumbersReportComponent,
    MigrationsRingCentralDashboardComponent,
    RingCentralCallQueueComponent,
    RingCentralCallQueuesListViewComponent,
    RingCentralAutoAttendantsListComponent,
    RingCentralAutoAttendantsDetailedViewComponent,
  ],
  exports: [
    MigrationsComponent,
    MigrationsTableComponent,
    MigrationsCreateComponent,
    MigrationsCiscoSiteManagementComponent,
    MigrationsCiscoSourceFieldMappingComponent,
    MigrationsCiscoDirectoryNumbersReportComponent,
    MigrationsCiscoHuntListsReportComponent,
    MigrationsCiscoHuntListsReportLineGroupsComponent,
    MigrationsDonutChartComponent,
    MigrationsCardAbstractDirective,
    MigrationsCiscoDashboardComponent,
    MigrationsTextCardComponent,
    MigrationsTextRowComponent,
    MigrationsCiscoAutoAttendantsExplorerComponent,
    MigrationsAutoAttendantsComponent,
    MigrationsAutoAttendantsDetailedViewComponent,
    MigrationsRingCentralNumbersReportComponent,
    MigrationsRingCentralDashboardComponent,
    RingCentralCallQueueComponent,
    RingCentralCallQueuesListViewComponent,
    RingCentralAutoAttendantsListComponent,
    RingCentralAutoAttendantsDetailedViewComponent,
  ],
  providers: [
    MicrosoftCucmE164TransformationRulesContext,
    MigrationsSuggestedCallingProductPipe,
    MicrosoftBulkProvisioningPollingService,
    MigrationsCiscoResource,
    MigrationsRingCentralResource,
  ],
})
export class MigrationsModule {}
